<div class="td-wb-form__sub-header-title">
  @if (iconId() !== undefined) {
    <td-wb-icon [iconId]="iconId()"
                size="16" />
  }
  <h3>
    <ng-content />
  </h3>
</div>
<ng-content select="td-wb-modal-header-buttons" />
